import affiliateReducer from '@/reducers/affiliate';
import infoStateReducer from '@/reducers/info-state';
import paymentReducer from '@/reducers/payment';
import planSummaryReducer from '@/reducers/plan-summary';
import uiStateReducer from '@/reducers/ui-state';

import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';

const persistConfig = {
  key: 'root',
  storage: storageSession,
};

const persistedAffiliateReducer = persistReducer(
  persistConfig,
  affiliateReducer,
);

export const store = configureStore({
  reducer: {
    planSummary: planSummaryReducer,
    uiState: uiStateReducer,
    infoState: infoStateReducer,
    payment: paymentReducer,
    affiliate: persistedAffiliateReducer,
  },
  middleware(getDefaultMiddleware) {
    return getDefaultMiddleware({
      serializableCheck: false,
    });
  },
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
